export const PRICE_COLOR = {
  BLACK: 'black',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_5B: 'grey5b',
  GREY_4A: 'grey4a',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  EGG: 'egg',
  BLUE_A: 'blue-a',
  BLUE_DARK: 'dark-blue',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  CORAL: 'coral',
  DARK_GREEN: 'dark-green',
  MEDIUM_GREEN: 'medium-green',
  LIGHT_GREEN: 'light-green',
  DARK_ORANGE: 'dark-orange',
  MEDIUM_ORANGE: 'medium-orange',
  LIGHT_ORANGE: 'light-orange',
  LIGHT_BLUE: 'light-blue',
  MEDIUM_BLUE: 'medium-blue',
  DARK_PURPLE: 'dark-purple',
  MEDIUM_PURPLE: 'medium-purple',
  LIGHT_PURPLE: 'light-purple',
  DARK_YELLOW: 'dark-yellow',
  MEDIUM_YELLOW: 'medium-yellow',
  LIGHT_YELLOW: 'light-yellow',
  ORCHID_DARK: 'orchid-dark',
  /* NEW COLORS */
  BLUE: 'blue',
  DARK_BLUE: 'dark-blue',
  BLUE_10: 'blue-10',
  BLUE_30: 'blue-30',
  BLUE_55: 'blue-55',
  WHITE: 'white',
  GREY_1: 'grey-1',
  GREY_2: 'grey-2',
  GREY_3: 'grey-3',
  GREY_4: 'grey-4',
  GREY_5: 'grey-5',
  GREY_6: 'grey-6',
  PURPLE: 'purple',
  PURPLE_10: 'purple-10',
  PURPLE_70: 'purple-70',
  GREEN: 'green',
  GREEN_10: 'green-10',
  GREEN_70: 'grenn-70',
  ORANGE: 'orange',
  ORANGE_10: 'orange-10',
  ORANGE_80: 'orange-80',
  RED: 'red',
  RED_10: 'red-10',
  RED_55: 'red-55',
  RED_70: 'red-70',
};

export const PRICE_SIZE = {
  SMALL: 'small',
  REGULAR: 'regular',
  EMP_40: 'emp-40',
  EMP_30: 'emp-30',
  EMP_28: 'emp-28',
  EMP_24: 'emp-24',
  EMP_22: 'emp-22',
  EMP_18: 'emp-18',
  EMP_16: 'emp-16',
  /* TEXT PRESETS */
  TEXT_PRESET10: 'tp10', // 64/72 40/48
  TEXT_PRESET9: 'tp9', // 56/64 40/48
  TEXT_PRESET8: 'tp8', // 40/48 32/40
  TEXT_PRESET7: 'tp7', // 40/48 24/32
  TEXT_PRESET6: 'tp6', // 32/40 24/32
  TEXT_PRESET5: 'tp5', // 28/32 22/24
  TEXT_PRESET4: 'tp4', // 20/28 18/24
  TEXT_PRESET3: 'tp3', // 18/24 16/24
  TEXT_PRESET2: 'tp2', // 16/24 14/20
  TEXT_PRESET1: 'tp1', // 14/20 12/16
  TEXT_PRESET0: 'tp0', // 12/16 10/14
};

export const PRICE_DECORATION = {
  LINE_THROUGH: 'linethrough',
  UNDERLINE: 'underline',
  NONE: 'none',
};

export const PRICE_OPACITY = {
  OP_1: 'op-1',
  OP_0_5: 'op-0-5',
  OP_0_25: 'op-0-25',
};

export const FONT_TYPE = {
  REGULAR: 'regular',
  LIGHT: 'light',
  THIN: 'thin',
  BOLD: 'bold',
  HAND: 'hand',
};

export const SEGMENT = {
  PARTICULARES: 'particulares',
  GP: 'gp',
  EMP: 'emp',
  EMPRESAS: 'empresas',
};

export const PRICE_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify',
};
